<template>
    <div id="listEnquiry">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid">
                    <div class="page-name">
                        <div class="page-title"> Inquiry List</div>
                    </div>
                    <!--page content-->
                    <div class="admin-page-content enquiry-list">
                        <data-table-filter-config :moduleName="'enquiryList'" ref="filterEnquiry" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'enquiryList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                        mode="remote"
                                        ref="enquiryListTable"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-row-click="viewEnquiry"
                                        :totalRows="totalRecords"
                                        title="Enquiries"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :paginate="true"
                                        :paginationOptions="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown:dropDownPerPage,
                                    dropdownAllowAll: false,
                                }"
                                />
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>

<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
    export default {
        name: "listUser",
        metaInfo() {
            return {
                title: "Inquiry List | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
        firstLoad:0,
        userColumns:[],
        columns: [
            {
                label: 'Name',
                field: 'name',
                filterable: true,
                hidden:false,
                fpFieldType:"text",
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Email',
                field: 'email',
                filterable: true,
                hidden:false,
                fpFieldType:"text",
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Email", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Phone',
                field: 'phone',
//                sortable:false,
                fpFieldType:"text",
                html: false,
                hidden:false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Phone", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                },
//                sortable: false,
            },
            {
                label: 'Asset Type',
                field: 'truck_type',
                fpFieldType:"option",
                hidden:false,
                html: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Truck Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Subject',
                field: 'subject',
                fpFieldType:"text",
                hidden:false,
                html: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Subject", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Inquiry Time',
                field: 'created_at',
                fpFieldType:"date",
                hidden:false,
                html: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        totalRecords: 0,
        permissions:[],
        cantAccessPage:"",
        loading:false,
        canview:false,
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_enquiry') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'view_enquiry') {
                    self.canview = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        },
    },
    mounted: function () {

        var self = this;
        self.getPermissions();
    },

    methods: {
        cancelAll: function (cancelAll) {
              this.$refs.enquiryListTable.unselectAllInternal();
            },

        viewEnquiry(params) {

            var self = this;
            if(self.canview == true){
                self.$router.push("/viewinquiry/" + params.row.id);
            }else{
                self.$swal('',"You Do Not Have Permission To View Enquiry",'info');
            }

        },

        /*onColumnFilter(params) {
            this.updateParams(params);
            {field: ('contact');
                field: ('email'); field: ('phone');
                field: ('truck_type'); field: ('subject');field: ('created_at')}
            this.serverParams.page = 1 ;
            var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
            var filters = filtersPr.columnFilters;

            if (this.firstLoad == 1 || filters.contact || filters.email || filters.phone || filters.truck_type
                || filters.subject || filters.created_at) {

                this.loadList();
            }

        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            console.log(this.serverParams.columnFilters.company);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});

            this.loadList();
        },
        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },

            });
            this.loadList();
        },
        //
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.serverParams.page = 1 ;
            this.totalRecords = self.totalRecords;
            this.loadList();
        },*/

        loadList(){

            var date = new Date();
            var offset = date.getTimezoneOffset();

            var self = this;
            self.loading = true;
            var fields = {
                offset: offset,
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/enquiry/list",
                type: "GET",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    // if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                        self.filteredFlag = false;
                    // }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'get-enquiry-list')
                }
            });
        }
    }
    };
</script>




// WEBPACK FOOTER //
// src/components/Enquiries/EnquiryList.vue